import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

import { SseService } from '@nano/core/sse';
import { RoutingService } from '@nano/common/routing';
import { MessageCount, MessageService, MessageThread } from '@nano/common/message';

@Component({
  selector: 'app-envelope',
  templateUrl: 'envelope.component.html',
  styleUrls: ['envelope.component.less'],
  standalone: false
})
export class EnvelopeComponent implements OnInit, OnDestroy {
  messageCount$: Observable<MessageCount>;
  unreadMessageThreads$: Observable<MessageThread[]>;
  dropdownVisible: boolean;

  private messageSentSubscription: Subscription;

  constructor(
    private messageService: MessageService,
    private sseService: SseService,
    private routingService: RoutingService
  ) {
    this.messageCount$ = this.messageService.messageCount$;
    this.unreadMessageThreads$ = this.messageService.unreadMessageThreads$;
  }

  ngOnInit(): void {
    this.messageService.loadUnreadMessageThreads();
    this.messageSentSubscription = this.sseService.incomingMessage$.subscribe(() => this.messageService.loadUnreadMessageThreads());
  }

  ngOnDestroy(): void {
    this.messageSentSubscription.unsubscribe();
  }

  startMessageThread(): void {
    this.dropdownVisible = false;
    this.routingService.navigateToStartMessageThread();
  }

  seeAll(): void {
    this.dropdownVisible = false;
    this.routingService.navigateToMessages();
  }

  changeDropdownVisible(dropdownVisible: boolean): void {
    this.dropdownVisible = dropdownVisible;
  }

  selectMessageThread(id: string): void {
    this.changeDropdownVisible(false);
    this.routingService.navigateToMessageThreadDetails(id);
  }
}
